import * as React from "react";
import { useState, useEffect, useMemo } from "react";
import { RowTitleButton } from "common/components";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import { useModalContext } from "common/contexts";
import DescriptionCell from "../DescriptionCell";
const TitleCell = ({ eventProcedure }) => {
  const [selectedProcedureId, setSelectedProcedureId] = useState(void 0);
  const { setModal, setEntity } = useModalContext();
  const onClickProcedure = () => {
    setSelectedProcedureId(eventProcedure.id);
    setEntity(eventProcedure);
    setModal("SHOW-EVENT-PROCEDURE-DETAILS");
  };
  useEffect(() => {
    if (eventProcedure.id === selectedProcedureId) setEntity(eventProcedure);
  }, [eventProcedure, selectedProcedureId, setEntity]);
  return /* @__PURE__ */ React.createElement(RowTitleButton, { onClick: onClickProcedure }, (eventProcedure == null ? void 0 : eventProcedure.title) || "No title set");
};
export const useColumnRenderers = () => {
  const { pluggableColumnRenderers } = usePluggableEntityTableElements(
    null,
    "event_procedure"
  );
  const columnRenderers = useMemo(
    () => ({
      attributes: {
        title: {
          width: 0.3,
          renderCell: (_, eventProcedure) => /* @__PURE__ */ React.createElement(TitleCell, { eventProcedure })
        },
        description: {
          width: 0.7,
          renderCell: (_, eventProcedure) => /* @__PURE__ */ React.createElement(DescriptionCell, { mdValue: eventProcedure.description })
        },
        ...pluggableColumnRenderers
      }
    }),
    [pluggableColumnRenderers]
  );
  return { columnRenderers };
};
